import React from 'react';
import Constants from '../../../definitions/constants';
import { Link } from 'react-router-dom';

const renderTopMenuItem = (item,i,props) => {
  var itemState = props.elementStates[item.key];
  
  if(typeof itemState === "undefined" 
     || !itemState.enabled) {
    return null;
  }
  
  if(item.childs) {
    return (
      <li key={i}>
        <div>{item.icon ? (<i className={"fas "+item.icon}/>) : null}</div>
        <div className="hover_menu_wrapper">
          <ul>{item.childs.map((childItem, j) => { return renderTopMenuItem(childItem,j,props); })}</ul>
        </div>
      </li>
    );
  }
  else {
    return (
      <li key={i} className={itemState.active ? "menu_item_active" : "menu_item_not_active"}>
        {item.route ? 
          (<Link data-key={item.key} to={item.route} onClick={props.handleClickTopMenuItem}>
            {item.icon ? (<i className={"fas "+item.icon}/>) : null}
            {item.label}
          </Link>) : 
          (<a data-key={item.key} onClick={props.handleClickTopMenuItem}>
            {item.icon ? (<i className={"fas "+item.icon}/>) : null}
            {item.label}
            {(item.key == Constants.app.menuKeys.NOTIFICATIONS && props.notViewedNotificationsCount) ? (
              <span className="top_menu_count">{props.notViewedNotificationsCount}</span>
            ) : null}
          </a>)
        }
      </li>);
  }
};

const TopMenu = props => {
  const {
    elements,
    elementStates,
    handleClickTopMenuItem,
    userProfile,
    show,
    notViewedNotificationsCount,
    additionControls
  } = props;
  return (
    <div className="dashboard_top_bar_menu">
      {show && (
        <div className="top_menu_container">
          {additionControls}
          {(userProfile && userProfile.customer_name) && (
            <div className="top_menu_info">
              <span className="top_menu_info_tenant">{userProfile.customer_name}</span>
              {" - " + userProfile.email}
            </div>
          )}
          <ul>{elements.map((item, i) => { return renderTopMenuItem(item,i,props); })}</ul>
        </div>
      )}
    </div>
  );
};

export default TopMenu;



// WEBPACK FOOTER //
// ./source/client/components/dashboard/topMenu.jsx